module.exports = {
	"suggestedEntries": [
		"May God bless you and your family in this time of sorrow.",
		"May your hearts soon be filled with wonderful memories of joyful times together as you celebrate a life well lived.",
		"May the love of friends and family carry you through your grief.",
		"As the days and weeks pass, and as you return to life's routine, may you continue to feel comforted by the love and support of family and friends.",
		"In loving memory of a wonderful person. We will love you and miss you always.",
		"Grief can be so hard, but our special memories help us cope. Remembering you and your loved one today and always."
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/suggestedEntries.json
// module id = 1638
// module chunks = 0